export default __webpack_public_path__ + "static/media/home-players-img.40ae9428.png";